import { COMMON_ERRORS } from 'modules/common/constants/errors.references';

export const ERROR_REFS = {
  ...COMMON_ERRORS,
  NOT_ENABLED_OR_NO_CONTEXT: 'NOT_ENABLED_OR_NO_CONTEXT',
  INVALID_KEY: 'INVALID_KEY',
  DFI0001: 'DFI0001',
};

export const AI_ASSISTANT_ERRORS = {
  [ERROR_REFS.DUPLICATE_KEY]: {
    title: 'aiAssistant:errors.duplicatedName',
    description: 'aiAssistant:errors.duplicatedNameDescription',
  },
  [ERROR_REFS.NOT_ENABLED_OR_NO_CONTEXT]: {
    description: 'aiAssistant:errors.NOT_ENABLED_OR_NO_CONTEXT',
  },
  [ERROR_REFS.INVALID_KEY]: {
    description: 'aiAssistant:errors.INVALID_KEY',
  },
  [ERROR_REFS.DFI0001]: {
    description: 'aiAssistant:errors.DFI0001',
  },
};
